import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';
import Data from '../../data';
import Utils from '../../utils';
import AddFedExDirectAccount from './AddFedExDirectAccount.component';
import { AddFedExWalletAccount } from './AddFedExWalletAccount.component';
import { FedExSelectOption } from './FedExSelectOption.component';

const { Session } = Utils;
const { InternalCapability, Capability } = Data;

type AddFedExAccountProps = {
	readonly completionCallback: (
		success: boolean,
		carrier?: string,
		locationsLength?: number,
		carrierType?: string
	) => void;
	readonly showSuccessModal?: boolean;
	readonly isEditing?: boolean;
	readonly custId?: string | null;
	readonly enterpriseLocations?: any[] | null;
	readonly hasUserOwnedAccount?: boolean | undefined;
};

export const AddFedExAccount = ({
	completionCallback,
	showSuccessModal = false,
	isEditing = false,
	custId = null,
	enterpriseLocations = null,
	hasUserOwnedAccount = undefined,
}: AddFedExAccountProps) => {
	if (!Session.hasCapability(Capability.Fedex as any)) {
		return null;
	}

	const { canAddFedexReseller } = useFlags();

	const isFedExWalletEnabled =
		canAddFedexReseller &&
		Session.hasCapability(InternalCapability.FedexWallet as any);
	const isFedExDirectEnabled = Session.hasCapability(
		InternalCapability.FedexDirect as any
	);

	if (isFedExDirectEnabled && isFedExWalletEnabled) {
		return (
			<FedExSelectOption
				completionCallback={completionCallback}
				showSuccessModal={showSuccessModal}
				isEditing={isEditing}
				custId={custId}
				enterpriseLocations={enterpriseLocations}
				hasUserOwnedAccount={hasUserOwnedAccount}
			/>
		);
	}

	if (isFedExWalletEnabled) {
		return (
			<AddFedExWalletAccount
				completionCallback={completionCallback}
				custId={custId}
				showSuccessModal={showSuccessModal}
			/>
		);
	}

	if (isFedExDirectEnabled) {
		return <AddFedExDirectAccount completionCallback={completionCallback} />;
	}

	return null;
};
